import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Customer } from './customer-settings.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root',
})
export class CustomerSettingsService {

  private url: string = environment.serverUrl;

  constructor(private http: HttpClient) {}

  postCustomer(customer: Customer): Observable<any> {
    return this.http.post(this.url + 'customers', customer);
  }

  putCustomer(customer: Customer): Observable<any> {
    return this.http.put(this.url + 'customers', customer);
  }

  deleteCustomer(index: number): Observable<any> {
    return this.http.delete(this.url + 'customers/' + index);
  }

  fetchCustomers(): Observable<any> {
    return this.http.get(this.url + 'customers');
  }


}
